module.exports = __webpack_public_path__ + "img/icon_heart_on.94275128.svg";